import { render, staticRenderFns } from "./IcoMagnifierZoom.vue?vue&type=template&id=432a2669"
import script from "./IcoMagnifierZoom.vue?vue&type=script&lang=js"
export * from "./IcoMagnifierZoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports